import { render, staticRenderFns } from "./CleanMob.vue?vue&type=template&id=8a75d984&"
import script from "./CleanMob.vue?vue&type=script&lang=js&"
export * from "./CleanMob.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports